import React from 'react';
import PageIntro from '../../components/PageIntro/PageIntro';
import TalentRequestTable from '../../components/Table/TalentRequestTable';

const ClientRequest = () => {
  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro title={'All Requests'} />
      <TalentRequestTable />
    </div>
  );
};

export default ClientRequest;
